import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ViewingsDispatchRequest } from "@/schemas";
import { getLifecycleBadgeClassName } from "../dispatchActions";
import {
  getInspectionTypeLabel,
  getLifecycleStatusLabel,
} from "../viewingLabels";
import ActivityTimeline from "./ActivityTimeline";
import UploadProgress from "./UploadProgress";
import ViewingFlags from "./ViewingFlags";
import { useIntl } from "react-intl";

export default function ViewingRequestCard({
  request,
  uploadProgress,
  onActivate,
}: {
  request: ViewingsDispatchRequest;
  uploadProgress: number;
  onActivate?: (request: ViewingsDispatchRequest) => void;
}) {
  const intl = useIntl();
  const activateRequest = () => onActivate?.(request);

  return (
    <Card>
      <CardHeader
        data-testid={`viewing-card-${request.id}`}
        tabIndex={onActivate ? 0 : undefined}
        role={onActivate ? "button" : undefined}
        className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between"
        onClick={activateRequest}
        onKeyDown={(event) => {
          if (!onActivate) return;
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            activateRequest();
          }
        }}
      >
        <div>
          <p className="text-xs text-muted-foreground">{request.evalionId}</p>
          <CardTitle className="text-lg">{request.title}</CardTitle>
          <CardDescription>{request.addressLine}</CardDescription>
        </div>
        <div className="flex flex-wrap gap-2">
          {request.inspectionType ? (
            <span className="rounded bg-muted px-2 py-1 text-xs font-medium text-muted-foreground">
              {getInspectionTypeLabel(intl, request.inspectionType)}
            </span>
          ) : null}
          <span className={getLifecycleBadgeClassName(request.lifecycleStatus)}>
            {getLifecycleStatusLabel(intl, request.lifecycleStatus)}
          </span>
        </div>
      </CardHeader>

      <CardContent className="space-y-4">
        <ViewingFlags request={request} />
        <UploadProgress progress={uploadProgress} />
        <ActivityTimeline request={request} />
      </CardContent>
    </Card>
  );
}
